import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-activity',
  templateUrl: '../views/activity.component.html',
  styleUrls: ['../../../css/activity.component.css','../../../css/paper-sets.component.css']
})
export class ActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/activity/components/activity.component.ts